import { render } from "./HeroiconsSolidReceiptTax.vue?vue&type=template&id=63aa6418"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidReceiptTax.vue"]])

export default __exports__